import type { SupportedLang } from 'app/lang';
import type { BrandName } from 'app/packages/brand';

// ---

type StrapiQueryParamsProps = {
  brandName?: BrandName;
  language?: SupportedLang;
  region?: string | null;
};

const LICENSE_SITE_REGION_KEY = 'LICENSE';

export function getStrapiQueryParams({ brandName, language, region }: StrapiQueryParamsProps) {
  const params = new URLSearchParams();

  params.set('filters[regions][name][$eqi]', region || LICENSE_SITE_REGION_KEY);
  brandName && params.set('filters[brands][name][$eqi]', brandName);
  language && params.set('locale', language);

  return params;
}
